module.exports = __webpack_public_path__ + "img/key-icon.76a6628c.svg";